/**
 * Helpers for endpoints that take a single URL-encoded `queryString` field
 * (Orders, Shipments, Purchase Orders). The API parses it as flat `key=value&key=value`
 * pairs and runs decodeURIComponent on every value, so every value is encoded here.
 */

/**
 * Convert an API query object (as emitted by FilterBar's buildApiQuery) into `key=value` parts.
 * - null/undefined values are skipped
 * - arrays are comma-joined (fields that need another format should use a `serialize` hook)
 * - everything else is stringified and URL-encoded
 */
export function toQueryStringParts(query: Record<string, unknown>): string[] {
    const parts: string[] = [];

    for (const [key, rawValue] of Object.entries(query)) {
        if (rawValue === null || rawValue === undefined) {
            continue;
        }

        const value = Array.isArray(rawValue) ? rawValue.map((v) => String(v)).join(",") : String(rawValue);

        parts.push(`${key}=${encodeURIComponent(value)}`);
    }

    return parts;
}

/**
 * Join query parts into a `?a=b&c=d` string; returns "" when there are no parts.
 */
export function toQueryString(parts: string[]): string {
    return parts.length ? `?${parts.join("&")}` : "";
}
